import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
// import Language from './Language';
import React, { useEffect } from 'react';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { getText } from '../common/utils/helpers';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { ReactComponent as IconHome } from '../assets/svg/home.svg';

const HEADER_TEXTS = {
  lv: {
    title: 'Gadsimta stāsti',
    description: 'Latvijas Nacionālais vēstures muzejs',
  },
  en: {
    title: 'Stories of Century',
    description: 'Latvian Museum of National History',
  },
};

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      headerContainerStyle: {
        width: '100%',
        height: `${C.HEADER_HEIGHT}px`,
        display: 'flex',
        justifyContent: 'center',
      },
      headerWrapperStyle: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      },
      titleContainerStyle: {
        position: 'absolute',
        marginBottom: '4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      titleStyle: {
        fontWeight: FONT_WEIGHT.bold,
        fontSize: '60px',
        lineHeight: '60px',
        fontFamily: FONTS.alegreya,
        color: COLORS.appBlue,
        whiteSpace: 'nowrap',
      },
      descriptionStyle: {
        fontWeight: FONT_WEIGHT.regular,
        fontSize: '20px',
        fontFamily: FONTS.alegreya,
        textAlign: 'center',
        color: COLORS.appBlack,
      },
      languageContainerStyle: {
        position: 'absolute',
        top: 0,
        left: 0,
        // zIndex: 1000,
        padding: '10px 0',
      },
      headerBackgroundStyle: {
        position: 'absolute',
        width: '450px',
        height: '100%',
        marginRight: '30px',
        background: COLORS.appSand,
        transform: 'skew(-30deg)',
      },
      iconHomeStyle: {
        position: 'absolute',
        fill: COLORS.white,
        left: 0,
        top: 0,
        padding: '10px 10px 10px 0',
        marginTop: '16px',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      [`@media (max-width: 1200px)`]: {
        iconHomeStyle: {
          paddingLeft: '20px',
        },
      },
      [`@media (max-width: 500px)`]: {
        iconHomeStyle: {
          display: 'none',
        },
      },
      [`@media (max-width: 410px)`]: {
        titleStyle: {
          fontSize: '50px',
          lineHeight: '50px',
        },
        descriptionStyle: {
          fontSize: '16px',
        },
      },
      [`@media (max-width: 310px)`]: {
        titleStyle: {
          fontSize: '40px',
          lineHeight: '40px',
        },
        descriptionStyle: {
          fontSize: '14px',
        },
      },
      [`@media (max-width: 260px)`]: {
        titleStyle: {
          fontSize: '34px',
          lineHeight: '34px',
        },
        descriptionStyle: {
          fontSize: '14px',
        },
      },
    })
);

const Header = (): JSX.Element => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search, pathname } = useLocation();
  const lng = useSelector((state: any) => state.app.lng);

  const goHome = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();

    navigate({ pathname: ROUTES.ROOT, search });
  };

  const { title, description } = HEADER_TEXTS[lng];
  const isRoot = pathname === ROUTES.ROOT;

  return (
    <div className={classes.headerContainerStyle}>
      <div className={classes.headerBackgroundStyle} />
      <div className={classes.headerWrapperStyle}>
        {!isRoot && (
          <IconHome className={classes.iconHomeStyle} onClick={goHome} />
        )}
        <div className={classes.titleContainerStyle} onClick={goHome}>
          <h1 className={classes.titleStyle}>{title}</h1>
          <h2 className={classes.descriptionStyle}>{description}</h2>
        </div>
        {/* <div className={classes.languageContainerStyle}>
          <Language />
        </div> */}
      </div>
    </div>
  );
};

export default Header;
